import React from "react";
import { useObserver } from "mobx-react-lite";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  MenuItem,
  IconButton,
  ListItemIcon,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import {
  AccountCircle as AccountCircleIcon,
  ExitToApp as ExitToAppIcon,
  Menu as MenuIcon,
  Build as BuildIcon,
} from "@material-ui/icons";
import { useAuthStore } from "stores/AuthStore";
import { Dropdown, Dialog } from "components";
import { useAccountFormStore } from "stores/AccountFormStore";
import AccountForm from "./AccountForm";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  logo: {
    height: "48px",
    verticalAlign: "bottom",
  },
}));

type Props = {
  hamburger?: {
    onClick: () => void;
  };
};

export default ({ hamburger }: Props) => {
  const authStore = useAuthStore();
  const accountFormStore = useAccountFormStore();
  const styles = useStyles();

  const openAccountForm = React.useCallback(() => {
    accountFormStore.open = true;
  }, [accountFormStore]);

  const closeAccountForm = React.useCallback(() => {
    accountFormStore.open = false;
  }, [accountFormStore]);

  return useObserver(() => (
    <>
      <AppBar position="static" color="default" component="header">
        <Toolbar className={styles.toolbar}>
          {hamburger && (
            <IconButton color="inherit" onClick={hamburger.onClick}>
              <MenuIcon />
            </IconButton>
          )}
          <Link to="/">
            <img
              className={styles.logo}
              src="logo/layapp-title-1000x300.png"
              alt="Logo"
            />
          </Link>

          <Dropdown icon={<AccountCircleIcon />}>
            <MenuItem onClick={openAccountForm}>
              <ListItemIcon>
                <BuildIcon />
              </ListItemIcon>
              アカウント設定
            </MenuItem>
            <MenuItem onClick={authStore.signOut}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              ログアウト
            </MenuItem>
          </Dropdown>
        </Toolbar>
      </AppBar>

      <Dialog
        buttonHidden
        title="アカウント設定"
        open={accountFormStore.open}
        onOpen={openAccountForm}
        onClose={closeAccountForm}
      >
        <AccountForm />
      </Dialog>
    </>
  ));
};
